import { render, staticRenderFns } from "./AddNewRole.vue?vue&type=template&id=9bc3edae"
import script from "./AddNewRole.vue?vue&type=script&lang=js"
export * from "./AddNewRole.vue?vue&type=script&lang=js"
import style0 from "./AddNewRole.vue?vue&type=style&index=0&id=9bc3edae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports